import {Model, ModelMixin} from '../../../../domain/model/common/model.class';
import {ContactInfo} from '../../../../domain/model/profile/contact-info.model';
import {User} from '../../../../domain/model/user/user.model';
import {Address} from '../../../../domain/model/common/values/address.class';
import {PremedicalEducation} from '../../../../domain/model/education/premedical/premedical-education.model';
import {Ecfmg} from '../../../../domain/model/education/ecfmg/ecfmg.model';
import {MedicalEducation} from '../../../../domain/model/education/medical/medical-education.model';
import {OtherEducation} from '../../../../domain/model/education/other/other-education.model';
import {Internship} from '../../../../domain/model/education/internship/internship.model';
import {Residency} from '../../../../domain/model/education/residency/residency.model';
import {FellowshipOrPreceptorship} from '../../../../domain/model/education/fellowship-or-preceptorship/fellowship-or-preceptorship.model';
import {MilitaryExperience} from '../../../../domain/model/work/military/military-experience.model';
import {Work} from '../../../../domain/model/work/history/work.model';
import {ProfessionalLicense} from '../../../../domain/model/licenses-certifications/professional/professional-license.model';
import {AbmsBoard} from '../../../../domain/model/licenses-certifications/board/abms/abms-board.model';
import {AbmsBoardSubspecialty} from '../../../../domain/model/licenses-certifications/board/abms/subspecialty/abms-board-subspecialty.model';
import {AbpsBoard} from '../../../../domain/model/licenses-certifications/board/abps/abps-board.model';
import {AoaBoard} from '../../../../domain/model/licenses-certifications/board/aoa/aoa-board.model';
import {AoaBoardSubspecialty} from '../../../../domain/model/licenses-certifications/board/aoa/subspecialty/aoa-board-subspecialty.model';
import {LifeCertification} from '../../../../domain/model/licenses-certifications/lifecertification/life-certification.model';
import {LicensingExamination} from '../../../../domain/model/licenses-certifications/licensingexamination/licensing-examination.model';
import {ContinuingMedicalEducation} from '../../../../domain/model/licenses-certifications/cme/continuing-medical-education.model';
import {Moment} from 'moment';
import {InactiveLicensesInformation} from '../../../../domain/model/licenses-certifications/inactive/inactive-licenses-information.model';
import moment = require('moment');

//region Other Classes
export class PersonalInfo {

    userInfo: User;
    address?: Address;
    contactInfo?: ContactInfo;

    constructor(jsonData: any = {}) {
        jsonData.userInfo = new User(jsonData.userInfo);
        if (jsonData.contactInfo) jsonData.contactInfo = new ContactInfo(jsonData.contactInfo);
        Object.assign(this, jsonData);
    }
}

export class EducationInfo {

    premedical?: PremedicalEducation;
    ecfmg?: Ecfmg;
    medical?: MedicalEducation;
    other: OtherEducation[];
    internship: Internship[];
    residency: Residency[];
    fellowshipOrPreceptorship: FellowshipOrPreceptorship[];

    constructor(jsonData: any = {}) {
        if (jsonData.premedical) jsonData.premedical = new PremedicalEducation(jsonData.premedical);
        if (jsonData.ecfmg) jsonData.ecfmg = new Ecfmg(jsonData.ecfmg);
        if (jsonData.medical) jsonData.medical = new MedicalEducation(jsonData.medical);
        jsonData.other = jsonData.other.map(it => new OtherEducation(it));
        jsonData.internship = jsonData.internship.map(it => new Internship(it));
        jsonData.residency = jsonData.residency.map(it => new Residency(it));
        jsonData.fellowshipOrPreceptorship = jsonData.fellowshipOrPreceptorship.map(it => new FellowshipOrPreceptorship(it));
        Object.assign(this, jsonData);
    }
}

export class WorkInfo {

    work: Work[];
    military?: MilitaryExperience;

    constructor(jsonData: any = {}) {
        jsonData.work = jsonData.work.map(it => new Work(it));
        if (jsonData.military) jsonData.military = new MilitaryExperience(jsonData.military);
        Object.assign(this, jsonData);
    }
}

export class LicensesAndCertifications {

    activeLicenses: ProfessionalLicense[];
    inactiveLicenses?: InactiveLicensesInformation;
    boardAffiliations: BoardAffiliationsInfo;
    otherCertifications: OtherCertificationsInfo;

    constructor(jsonData: any = {}) {
        jsonData.activeLicenses = jsonData.activeLicenses.map(it => new ProfessionalLicense(it));
        if (jsonData.inactiveLicenses) jsonData.inactiveLicenses = new InactiveLicensesInformation(jsonData.inactiveLicenses);
        jsonData.boardAffiliations = new BoardAffiliationsInfo(jsonData.boardAffiliations);
        jsonData.otherCertifications = new OtherCertificationsInfo(jsonData.otherCertifications);
        Object.assign(this, jsonData);
    }
}

export class BoardAffiliationsInfo {

    abmsBoard: AbmsBoardEntry[];
    abpsBoard: AbpsBoard[];
    aoaBoard: AoaBoardEntry[];
    specialtyExaminationDate?: Moment;

    constructor(jsonData: any = {}) {
        jsonData.abmsBoard = jsonData.abmsBoard.map(it => new AbmsBoardEntry(it));
        jsonData.abpsBoard = jsonData.abpsBoard.map(it => new AbpsBoard(it));
        jsonData.aoaBoard = jsonData.aoaBoard.map(it => new AoaBoardEntry(it));
        if (jsonData.specialtyExaminationDate) jsonData.specialtyExaminationDate = moment(jsonData.specialtyExaminationDate);
        Object.assign(this, jsonData);
    }
}

interface BoardWithSubspecialtiesEntry<M, S> {
    main: M;
    subspecialties: S[];
}

export class AbmsBoardEntry implements BoardWithSubspecialtiesEntry<AbmsBoard, AbmsBoardSubspecialty> {

    main: AbmsBoard;
    subspecialties: AbmsBoardSubspecialty[];

    constructor(jsonData: any = {}) {
        jsonData.main = new AbmsBoard(jsonData.main);
        jsonData.subspecialties = jsonData.subspecialties.map(it => new AbmsBoardSubspecialty(it));
        Object.assign(this, jsonData);
    }
}

export class AoaBoardEntry implements BoardWithSubspecialtiesEntry<AoaBoard, AoaBoardSubspecialty> {

    main: AoaBoard;
    subspecialties: AoaBoardSubspecialty[];

    constructor(jsonData: any = {}) {
        jsonData.main = new AoaBoard(jsonData.main);
        jsonData.subspecialties = jsonData.subspecialties.map(it => new AoaBoardSubspecialty(it));
        Object.assign(this, jsonData);
    }
}

export class OtherCertificationsInfo {

    lifeCertifications: LifeCertification[];
    licensingExaminations: LicensingExamination[];
    cme: ContinuingMedicalEducation[];

    constructor(jsonData: any = {}) {
        jsonData.lifeCertifications = jsonData.lifeCertifications.map(it => new LifeCertification(it));
        jsonData.licensingExaminations = jsonData.licensingExaminations.map(it => new LicensingExamination(it));
        jsonData.cme = jsonData.cme.map(it => new ContinuingMedicalEducation(it));
        Object.assign(this, jsonData);
    }
}
//endregion

/**
 * Created by Rodrigo Quesada on 20/03/17.
 */
export class CvModel extends ModelMixin() implements Model<CvModel> {

    TYPE = CvModel;

    personalInfo: PersonalInfo;
    education: EducationInfo;
    work: WorkInfo;
    licensesAndCertifications: LicensesAndCertifications;

    constructor(jsonData: any = {}) {
        super();
        jsonData.personalInfo = new PersonalInfo(jsonData.personalInfo);
        jsonData.education = new EducationInfo(jsonData.education);
        jsonData.work = new WorkInfo(jsonData.work);
        jsonData.licensesAndCertifications = new LicensesAndCertifications(jsonData.licensesAndCertifications);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/download/model/cv.model.ts